module.exports = __webpack_public_path__ + "static/img/Jaipur_Cinema-4.a3238dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsImages/Jaipur_Cinema-4.jpg
// module id = f36I
// module chunks = 11